import { createNamedContext } from '@/utils';

type FileUploadReviewStepperActions = {
  next: () => void;
};

export const FileUploadReviewStepperActionsContext = createNamedContext<FileUploadReviewStepperActions>(undefined, 'FileUploadReviewStepperActionsContext');